import React from "react";
import styled from "styled-components";

const ScheduleSection = styled.section`
  background-color: var(--surface);
  position: relative;
  overflow: hidden;
`;

const ScheduleContainer = styled.div`
  max-width: 1400px; // Povećano sa 1200px za više širine
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
  color: var(--text);

  span {
    color: var(--primary);
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 8px;
      background: linear-gradient(90deg, var(--primary), var(--accent));
      z-index: -1;
      opacity: 0.2;
    }
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.1rem;
  color: var(--textSecondary);
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3rem;
`;

const WorkshopsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem; // Smanjeno sa 2rem da bi se dalo više prostora karticama
  margin-top: 2rem;

  /* Tablet: 2 kartice po redu */
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Desktop: 4 kartice po redu */
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const WorkshopCard = styled.div`
  background: var(--background);
  border-radius: 20px;
  padding: 1.75rem; // Blago smanjeno sa 2rem
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: ${(props) =>
    props.theme.colors.background === "#FFFFFF"
      ? "0 4px 20px rgba(37, 99, 235, 0.1)"
      : "0 4px 20px rgba(0, 0, 0, 0.2)"};
  height: 100%; // Osigurava da sve kartice imaju istu visinu

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${(props) =>
      props.theme.colors.background === "#FFFFFF"
        ? "0 8px 30px rgba(37, 99, 235, 0.15)"
        : "0 8px 30px rgba(0, 0, 0, 0.3)"};
  }
`;

const WorkshopDate = styled.div`
  display: inline-block;
  background: ${(props) => props.color || "var(--primary)"};
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  opacity: 0.9;
`;

const WorkshopTitle = styled.h3`
  font-size: 1.5rem;
  color: var(--text);
  margin-bottom: 0.75rem;
`;

const WorkshopDescription = styled.p`
  color: var(--textSecondary);
  margin-bottom: 1.5rem;
  line-height: 1.5;
  font-size: 0.95rem;
  flex-grow: 1; // Omogućava da opis zauzme raspoloživi prostor
`;

const WorkshopTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: auto; // Pomera tagove na dno kartice
`;

const WorkshopTag = styled.span`
  background: ${(props) => props.color || "rgba(30, 64, 175, 0.1)"};
  color: var(--primary);
  padding: 0.3rem 0.8rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 500;
`;

const RegisterButton = styled.button`
  background: linear-gradient(90deg, var(--primary), var(--secondary));
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  border: none;
  font-weight: 600;
  margin-top: 1rem;
  cursor: pointer;
  width: 100%;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(30, 64, 175, 0.2);
  }
`;

const SponsorDivider = styled.div`
  height: 3px;
  width: 70%;
  background: linear-gradient(
    to right,
    ${(props) => props.theme.colors.primary},
    transparent
  );
  margin: 0.8rem 0;
`;

// Dodana nova komponenta za kontrolu visine kartica
const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

function Schedule() {
  const workshops = [
    {
      id: 1,
      title: "Početak prijava",
      description:
        "Dragi učesnici, Sa zadovoljstvom obaveštavamo vas da su prijave za UNINP Hackathon 2025 otvorene. Svi zainteresovani timovi i pojedinci mogu se prijaviti putem naše zvanične veb stranice. Prijavite se odmah i pokažite svoje veštine!",
      date: "od 15. do 23. April 2025.",
      color: "var(--primary)",
    },
    {
      id: 2,
      title: "Testiranje timova",
      description:
        "Želimo vas obavestiti da će se testiranje timova za UNINP Hackathon održati 24. Aprila 2025. Ovo je prilika da se timovi upoznaju, testiraju svoje veštine i pripreme za izazove koji ih očekuju tokom hackathona. Budite spremni i pokažite svoj maksimum!",
      date: "24. April 2025.",
      color: "var(--secondary)",
    },
    {
      id: 3,
      title: "Početak Hakatona",
      description:
        "Sa zadovoljstvom vas obaveštavamo da UNINP Hackathon 2025 počinje 26. aprila 2025. Svi prijavljeni timovi i pojedinci su dobrodošli da se pridruže ovom događaju koji slavi inovaciju i tehnološki napredak. Pripremite se za intenzivno takmičenje i priliku da svoje ideje pretvorite u stvarnost!",
      date: "25. April 2025.",
      time: "16:00",
      color: "var(--accent)",
    },
    {
      id: 4,
      title: "Završna ceremonija",
      description:
        "Završna ceremonija Hakatona , kao i ocenjivanje radova, održaće se 27. Aprila 2025. Biće to prilika da se proglase pobednici, da se pokaže šta su timovi postigli tokom hakatona i da se nagrade najuspešniji projekti. Pratite našu veb stranicu i društvene mreže kako biste bili u toku sa svim detaljima o ceremoniji i rezultatima!",
      date: "26. April 2025.",
      time: "17:00 ",
      color: "#4F46E5",
    },
  ];

  return (
    <ScheduleSection id="kalendar">
      <ScheduleContainer>
        <SectionTitle>
          Predstojeći <span>Događaji</span>
        </SectionTitle>
        <WorkshopsGrid>
          {workshops.map((workshop) => (
            <WorkshopCard key={workshop.id}>
              <CardContent>
                <WorkshopDate color={workshop.color}>
                  {workshop.date} {workshop.time && `• ${workshop.time}`}
                </WorkshopDate>
                <WorkshopTitle>{workshop.title}</WorkshopTitle>
                <SponsorDivider />
                <WorkshopDescription>
                  {workshop.description}
                </WorkshopDescription>
                <WorkshopTags>
                  {workshop.tags &&
                    workshop.tags.map((tag, i) => (
                      <WorkshopTag key={i} color={`${workshop.color}15`}>
                        {tag}
                      </WorkshopTag>
                    ))}
                </WorkshopTags>
              </CardContent>
            </WorkshopCard>
          ))}
        </WorkshopsGrid>
      </ScheduleContainer>
    </ScheduleSection>
  );
}

export default Schedule;
